module.exports = __webpack_public_path__ + "img/logo.95e0ad48.png";